import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Cpu, ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { formatApiError } from "@/lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("admin@techvalue.in");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back, Admin");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4 relative overflow-hidden" data-testid="admin-login-page">
      <div className="absolute inset-0 tv-radial pointer-events-none" />
      <div className="absolute inset-0 tv-grid-bg opacity-50 pointer-events-none" />
      <Card className="w-full max-w-md relative tv-glass border-border">
        <CardHeader className="text-center">
          <Link to="/" className="mx-auto mb-4 flex items-center gap-3">
            <img src="/tech-value-logo.png" alt="Tech Value" className="w-12 h-12 object-contain" />
            <div className="text-left leading-none">
              <div className="font-brand font-extrabold text-2xl tracking-tighter">
                Tech <span className="bg-gradient-to-r from-amber-500 via-yellow-500 to-slate-500 bg-clip-text text-transparent">Value</span>
              </div>
              <div className="text-[10px] font-mono uppercase tracking-widest text-muted-foreground mt-1">Admin Console</div>
            </div>
          </Link>
          <CardTitle className="text-2xl">Sign in</CardTitle>
          <p className="text-sm text-muted-foreground">Secure JWT-based admin authentication</p>
        </CardHeader>
        <CardContent>
          <form onSubmit={submit} className="space-y-4">
            <div className="grid gap-2">
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email-input" required />
            </div>
            <div className="grid gap-2">
              <Label htmlFor="pw">Password</Label>
              <Input id="pw" type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password-input" required />
            </div>
            <Button type="submit" className="w-full bg-primary hover:bg-primary/90" disabled={loading} data-testid="admin-login-submit">
              {loading ? "Signing in…" : (<><ShieldCheck className="w-4 h-4 mr-2" /> Sign in securely</>)}
            </Button>
          </form>
          <p className="text-center text-xs text-muted-foreground mt-6">
            <Link to="/" className="hover:text-primary">← Back to site</Link>
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
